<template>
    <div class="">
        <div class="card bg-card">
            <div class="card-header">
                Información del Envío
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-lg-4">
                        <label class="required" for="cod_metodo_envio_id">
                            Area Solicitante
                        </label>
                        <select class="form-control" v-model="formGestion.metodo_envio_id" id="cod_metodo_envio_id">
                            <option value="">Seleccione un área</option>
                            <option v-for="item in codigosMetodoEnvio" :key="item.id" :value="item.id">
                                {{ item.codigo }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group col-lg-2">
                        <label class="required" for="id_solicitudes_envio">
                            Solicitud de Envío
                        </label>
                        <select class="form-control" v-model="formGestion.id_solicitudes_envio"
                            id="id_solicitudes_envio">
                            <option value="">Seleccione una solicitud</option>
                            <option v-for="item in solicitudesEnvio" :value="item.id" :key="item.id">
                                {{ item.nombre }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-lg-2">
                        <label class="required" for="modalidad_envio">Modalidad de Envío </label>
                        <select v-model="formGestion.modalidad_envio" class="form-control" id="modalidad_envio">
                            <option value="CONSOLIDADO">CONSOLIDADO</option>
                            <option value="EXCLUSIVO">EXCLUSIVO</option>
                        </select>
                    </div>

                    <div class="form-group col-lg-2">
                        <label class="required" for="programacion">Cita</label>
                        <select v-model="formGestion.programacion" id="programacion" class="form-control">
                            <option value="normal">Sin cita</option>
                            <option value="cita">Con cita</option>
                            <option value="publico">Público</option>
                        </select>
                    </div>

                    <div v-if="formGestion.programacion == 'publico'" class="form-group col-lg-2">
                        <label for="tipo_ingreso">Tipo de Ingreso</label>
                        <select v-model="formGestion.tipo_ingreso" id="tipo_ingreso" class="form-control">
                            <option value="almacen">Por Almacen</option>
                            <option value="contacto">Con Contacto</option>
                        </select>
                    </div>

                    <div v-if="formGestion.programacion" class="form-group col-lg-2">
                        <label for="tipo_cita">Programación</label>
                        <select v-model="formGestion.tipo_cita" id="tipo_cita" class="form-control">
                            <option value="recojo">Recojo</option>
                            <option value="entrega">Entrega</option>
                        </select>
                    </div>

                    <div class="form-group col-lg-2">
                        <label for="solicitante">Solicitante</label>
                        <input v-model="formGestion.solicitante" class="form-control" type="text" name="solicitante"
                            id="solicitante">
                    </div>

                    <div class="form-group col-lg-3">
                        <label for="peso_volumen" class="required">Peso Vol(cm3)</label>
                        <input v-model="formGestion.peso_volumen" class="form-control" type="number" name="peso_volumen"
                            id="peso_volumen">
                    </div>

                    <div class="form-group col-lg-12">
                        <label for="observaciones">Observaciones</label>
                        <textarea v-model="formGestion.observaciones" class="form-control no-resize" id="observaciones"
                            cols="30" rows="5"></textarea>
                    </div>

                    <div class="form-group col-lg-12" v-if="formGestion.isEmergency">
                        <label for="observaciones_emergencia" class="required">Motivo de la Emergencia/Urgencia</label>
                        <textarea v-model="formGestion.observaciones_emergencia" class="form-control no-resize"
                            id="observaciones_emergencia" cols="30" rows="5"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                Sección de Horarios
            </div>

            <div class="card-body py-4">
                <div class="row">
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="fecha_salida">Fecha de Salida</label>
                        <input type="date" v-model="formGestion.fecha_salida" class="form-control" id="fecha_salida" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_salida">Hora de Salida</label>
                        <input type="time" v-model="formGestion.hora_salida" class="form-control" id="hora_salida" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="fecha_entrada">Fecha de Entrega</label>
                        <input type="date" v-model="formGestion.fecha_entrega" class="form-control"
                            id="fecha_entrada" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_llegada_maxima">Hora de Entrega Máxima</label>
                        <input type="time" v-model="formGestion.hora_llegada_maxima" class="form-control"
                            id="hora_llegada_maxima" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_recojo_documento">
                            Hora de recojo del documento
                        </label>
                        <input type="time" v-model="formGestion.hora_recojo_documento" class="form-control"
                            id="hora_recojo_documento" />
                    </div>



                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_llegada_origen_2">
                            Hora de llegada al origen 1
                        </label>
                        <input type="time" v-model="formGestion.hora_llegada_origen_2" class="form-control"
                            id="hora_llegada_origen_2" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_salida_origen_2">
                            Hora de salida del origen 1
                        </label>
                        <input type="time" v-model="formGestion.hora_salida_origen_2" class="form-control"
                            id="hora_salida_origen_2" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_llegada_origen">Hora de Llegada al Origen 2</label>
                        <input type="time" v-model="formGestion.hora_llegada_origen" class="form-control"
                            id="hora_llegada_origen" />
                    </div>


                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_salida_origen">Hora de Salida de Origen 2</label>
                        <input type="time" v-model="formGestion.hora_salida_origen" class="form-control"
                            id="hora_salida_origen" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_llegada_destino">Hora de Llegada al Destino 2</label>
                        <input type="time" v-model="formGestion.hora_llegada_destino" class="form-control"
                            id="hora_llegada_destino" />
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="hora_salida_destino">Hora de Salida del Destino 2</label>
                        <input type="time" v-model="formGestion.hora_salida_destino" class="form-control"
                            id="hora_salida_destino" />
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="tiempo_transito">Tiempo de transito</label>
                        <input type="text" readonly v-model="formGestion.tiempo_transito" class="form-control"
                            id="tiempo_transito" />
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="tiempo_entrega">Tiempo de entrega</label>
                        <input type="text" readonly v-model="formGestion.tiempo_entrega" class="form-control"
                            id="tiempo_entrega" />
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="horas_extra">Horas extras</label>
                        <input type="number" step="0.5" min="0" v-model="formGestion.horas_extra" class="form-control"
                            id="horas_extra" />
                    </div>
                    <div class="form-group mt-2 col-lg-4">
                        <label for="agencia">Agencia</label>
                        <select v-model="formGestion.agencia" class="form-control" name="agencia" id="agencia">
                            <option value="" disabled>Seleccione una agencia</option>
                            <option value="SHALOM-RIMAC">SHALOM-RIMAC</option>
                            <option value="CRUZDELNORTE-ATE">CRUZDELNORTE-ATE</option>
                            <option value="FLORES-SANJUAN">FLORES-SANJUAN</option>
                        </select>
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label for="clave_agencia">Clave en agencia</label>
                        <input type="text" v-model="formGestion.clave_agencia" class="form-control" id="clave_agencia"
                            name="clave_agencia">
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label for="fecha_entrega_agencia">Fecha de entrega en agencia</label>
                        <input type="date" v-model="formGestion.fecha_entrega_agencia" class="form-control"
                            id="fecha_entrega_agencia" name="fecha_entrega_agencia">
                    </div>

                    <!-- Rango horario de entrega en agencia -->
                    <div class="form-group mt-2 col-lg-2">
                        <label for="rango_horario_agencia">Rango de horario de entrega</label>
                        <input type="time" v-model="formGestion.rango_horario_agencia" class="form-control" name="rango_horario_agencia" id="rango_horario_agencia">                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row">

            <div class="col-lg-12">
                <div class="card mt-3">
                    <div class="card-header">
                        Sección de Documentos
                    </div>
                    <div class="card-body py-4">
                        <div class="row">
                            <div class="form-group mt-2 col-lg-2">
                                <label class="required" for="nro_pedido">
                                    N° Pedido
                                </label>
                                <input type="text" v-model="formDocumento.nro_pedido" class="form-control"
                                    id="nro_pedido" />
                            </div>
                            <div class="form-group mt-2 col-lg-2">
                                <label class="required" for="orden_compra">
                                    N° Orden de Compra
                                </label>
                                <input type="text" v-model="formDocumento.orden_compra" class="form-control"
                                    id="orden_compra" />
                            </div>
                            <div class="form-group mt-2 col-lg-2">
                                <label class="required" for="numero_factura">
                                    N° Factura
                                </label>
                                <input type="text" v-model="formDocumento.numero_factura" class="form-control"
                                    id="numero_factura" />
                            </div>
                            <div class="form-group mt-2 col-lg-2">
                                <label class="required" for="guia_remitente">
                                    Guia del Remitente
                                </label>
                                <input type="text" v-model="formDocumento.guia_remitente" class="form-control"
                                    id="guia_remitente" />
                            </div>
                            <div class="form-group mt-2 col-lg-2">
                                <label class="required" for="guia_transportista">
                                    N° Guia de Transportista
                                </label>
                                <input type="text" v-model="formDocumento.guia_transportista" class="form-control"
                                    id="guia_transportista" />
                            </div>
                            <div class="form-group col-md-1 d-flex align-items-end">
                                <a role="button" class="btn btn-sm btn-info d-flex align-items-center gap-2 text-white"
                                    @click="agregarDocumento()">
                                    <i class="bi bi-plus-circle"></i>
                                </a>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="table-responsive mt-2">
                                            <table
                                                class="table table-bordered table-hover table-striped table-font-small">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>Número de Pedido</th>
                                                        <th>N° Orden de compra</th>
                                                        <th>N° factura</th>
                                                        <th>Guia de remisión</th>
                                                        <th>Guia Transportista</th>
                                                        <th>Documentos extras</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(doc, index) in formGestion.detalles" :key="index">
                                                        <td>
                                                            <input type="text" v-model="doc.nro_pedido"
                                                                class="form-control" />
                                                        </td>
                                                        <td>
                                                            <input type="text" v-model="doc.orden_compra"
                                                                class="form-control" />
                                                        </td>
                                                        <td>
                                                            <input type="text" v-model="doc.numero_factura"
                                                                class="form-control" />
                                                        </td>
                                                        <td>
                                                            <input type="text" v-model="doc.guia_remitente"
                                                                class="form-control" />
                                                        </td>
                                                        <td>
                                                            <input type="text" v-model="doc.guia_transportista"
                                                                class="form-control" />
                                                        </td>
                                                        <td>
                                                            <input type="text" v-model="doc.documentos_extras"
                                                                class="form-control" />
                                                        </td>
                                                        <td>
                                                            <a class="btn btn-sm btn-danger text-white" role="button"
                                                                @click="eliminarDocumento(index)">
                                                                <i class="bi bi-trash"></i>
                                                            </a>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="card mt-3">
                    <div class="card-header">
                        Sección de Fletes (Sin IGV)
                    </div>

                    <div class="card-body py-4">
                        <div class="row">
                            <div class="form-group mt-2 col-lg-3">
                                <label class="required" for="flete">Flete</label>
                                <input type="text" v-model="formGestion.flete" class="form-control" id="flete" />
                            </div>

                            <div class="form-group mt-2 col-lg-3">
                                <label class="required" for="flete_cancelacion">Flete Cancelación</label>
                                <input type="text" v-model="formGestion.flete_cancelacion" class="form-control"
                                    id="flete_cancelacion" />
                            </div>

                            <div class="form-group mt-2 col-lg-4">
                                <label class="required" for="flete_visita_extra">Flete de envios por agencia</label>
                                <input type="text" v-model="formGestion.flete_envio_agencia" class="form-control"
                                    id="flete_envio_agencia" />
                            </div>

                            <div class="form-group mt-2 col-lg-3">
                                <label class="required" for="flete_cancelacion">Flete Hora Extra</label>
                                <input type="text" v-model="formGestion.flete_hora_extra" class="form-control"
                                    id="flete_cancelacion" />
                            </div>

                            <div class="form-group mt-2 col-lg-3">
                                <label class="required" for="flete_local_urgencia">Flete Local/Urgencia</label>
                                <input type="text" v-model="formGestion.flete_local_urgencia" class="form-control"
                                    id="flete_local_urgencia" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card mt-3">
                    <div class="card-header">
                        Sección de Gastos(Sin IGV)
                    </div>

                    <div class="card-body py-4">
                        <div class="row">
                            <div class="form-group mt-2 col-lg-3">
                                <label class="required" for="gastos_admin">
                                    Gastos Administrativos
                                </label>
                                <input type="text" v-model="formGestion.gastos_administrativo" class="form-control"
                                    id="gastos_admin" />
                            </div>
                            <div class="form-group mt-2 col-lg-3">
                                <label class="required" for="gastos_total">
                                    Gasto total de transporte
                                </label>
                                <input type="text" readonly v-model="formGestion.gastos_total" class="form-control"
                                    id="gastos_total" />
                            </div>
                            <div class="form-group mt-2 col-lg-6">
                                <label class="required" for="detalle_gastos_admin">
                                    Detalle de Gastos Administrativos
                                </label>
                                <input type="text" v-model="formGestion.detalle_gasto_administrativo"
                                    class="form-control" id="detalle_gastos_admin" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-3">
            <div class="card-header">
                Sección de Paquetes
            </div>

            <div class="card-body py-4">
                <div class="row">
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="cant_bultos">
                            Cant. de Bultos en Origen
                        </label>
                        <input type="text" v-model="formGestion.cantidad_bultos_origen" class="form-control"
                            id="cant_bultos" />
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="cant_bultos_destino">
                            Cant. de Bultos en Destino
                        </label>
                        <input type="text" v-model="formGestion.cantidad_bultos_destino" class="form-control"
                            id="cant_bultos_destino" />
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="peso_bruto">
                            Peso Bruto (KG)
                        </label>
                        <input type="text" v-model="formGestion.peso_bruto" class="form-control" id="peso_bruto" />
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                Sección de Entrega
            </div>

            <div class="card-body py-4">
                <div class="row">
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="conformidad">
                            Conformidad de entrega
                        </label>
                        <select v-model="formGestion.conformidad_entrega" name="estado" id="estado"
                            class="form-control">
                            <option value="ACEPTADO">ACEPTADO</option>
                            <option value="RECHAZADO">RECHAZADO</option>
                            <option value="EN CUSTODIA">EN CUSTODIA</option>
                            <option value="CANCELADO">CANCELADO</option>
                        </select>
                    </div>
                    <div class="form-group mt-2 col-lg-4">
                        <label class="required" for="causa_entrega ">
                            Causa de la Conformidad de entrega
                        </label>
                        <select name="" id="causa_entrega" v-model="formGestion.causa_entrega" class="form-control">
                            <option v-for="item in causasConfomidad" :value="item.nombre" :key="item.id">{{ item.nombre
                            }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group mt-2 col-lg-6">
                        <label class="required" for="detalle_causa_entrega">
                            Detalle de causa de Conformidad de entrega
                        </label>
                        <input type="text" v-model="formGestion.detalle_causa_entrega" class="form-control"
                            id="detalle_causa_entrega" />
                    </div>
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required" for="entrega_sin_danio">
                            Entrega Completa y sin daño
                        </label>
                        <select v-model="formGestion.entrega_sin_danio" name="estado" id="entrega_sin_danio"
                            class="form-control">
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>
                    <div class="form-group mt-2 col-lg-4">
                        <label class="required" for="causa_entrega_sin_danio ">
                            Causa de la Entrega Completa y sin daño
                        </label>
                        <select name="" id="causa_entrega_sin_danio" v-model="formGestion.causa_entrega_sin_danio"
                            class="form-control">
                            <option v-for="item in causasEntregaCompleta" :value="item.nombre" :key="item.id">{{
                                item.nombre
                                }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group mt-2 col-lg-6">
                        <label class="required" for="detalle_entrega_sin_danio">
                            Detalle de Causa de la Entrega Completa y sin daño
                        </label>
                        <input type="text" v-model="formGestion.detalle_entrega_sin_danio" class="form-control"
                            id="detalle_entrega_sin_danio" />
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-3">


            <div class="card-header">
                Cumplimiento y Tiempos de Ruta
            </div>

            <div class="card-body py-4">
                <div class="row">
                    <!-- Inicio de ruta -->
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required">¿Inicio a tiempo?</label>
                        <select v-model="formGestion.cumplimiento_inicio_ruta" class="form-control">
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-4">
                        <label class="required">Causa inicio ruta</label>
                        <select v-model="formGestion.causa_inicio_ruta" class="form-control">
                            <option value="NINGUNO">NINGUNO</option>
                            <option value="DEMORA POR CASO FORTUITO">DEMORA POR CASO FORTUITO</option>
                            <option value="DEMORA POR ANW">DEMORA POR ANW</option>
                             <option value="OTROS">OTROS</option>
                        </select>
                    </div>

                    <!-- Punto origen -->
                    <div class="form-group mt-2 col-lg-2">
                        <label class="required">Lead time origen</label>
                        <select v-model="formGestion.lead_time_origen" class="form-control">
                            <option value="">Seleccione...</option>
                            <option value="1H 30 MIN">1H 30 MIN</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label class="required">¿Cumple tiempo origen?</label>
                        <select v-model="formGestion.cumplimiento_origen" class="form-control">
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-4">
                        <label>Causa cumplimiento origen</label>
                        <select v-model="formGestion.causa_cumplimiento_origen" class="form-control">
                            <option value="NINGUNO">NINGUNO</option>
                            <option value="DEMORA POR CASO FORTUITO">DEMORA POR CASO FORTUITO</option>
                            <option value="DEMORA POR ANW">DEMORA POR ANW</option>
                            <option value="OTROS">OTROS</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-6">
                        <label>Detalle origen</label>
                        <input type="text" v-model="formGestion.detalle_cumplimiento_origen" class="form-control" />
                    </div>

                    

                    <div class="form-group mt-2 col-lg-2">
                        <label>¿Cumple tiempo destino?</label>
                        <select v-model="formGestion.cumplimiento_destino" class="form-control">
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-4">
                        <label>Causa cumplimiento destino</label>
                        <select v-model="formGestion.causa_cumplimiento_destino" class="form-control">
                            <option value="NINGUNO">NINGUNO</option>
                            <option value="DEMORA POR CASO FORTUITO">DEMORA POR CASO FORTUITO</option>
                            <option value="DEMORA POR ANW">DEMORA POR ANW</option>
                            <option value="DEMORA POR CLIENTE DE DRAEGER">DEMORA POR CLIENTE DE DRAEGER</option>
                            <option value="DEMORA POR DRAEGER">DEMORA POR DRAEGER</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-6">
                        <label>Detalle destino</label>
                        <input type="text" v-model="formGestion.detalle_cumplimiento_destino" class="form-control" />
                    </div>

                    <!-- Subida de cargos -->
                    <div class="form-group mt-2 col-lg-2">
                        <label>Lead time cargos</label>
                        <select v-model="formGestion.lead_time_cargos" class="form-control">
                            <option value="">Seleccione...</option>
                            <option value="4 HORAS">4 HORAS</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label>¿Cumple cargos?</label>
                        <select v-model="formGestion.cumplimiento_cargos" class="form-control">
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>

                    <!-- Retorno documental -->
                    <div class="form-group mt-2 col-lg-2">
                        <label>Estado retorno doc.</label>
                        <select v-model="formGestion.estado_retorno_doc" class="form-control">
                            <option value="CUSTODIA">CUSTODIA</option>
                            <option value="EN TRANSITO">EN TRANSITO</option>
                            <option value="ENTREGADO">ENTREGADO</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label>Lead time retorno</label>
                        <select v-model="formGestion.lead_time_retorno_doc" class="form-control">
                            <option value="24 HORAS">24 HORAS</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-2">
                        <label>¿Cumple retorno doc?</label>
                        <select v-model="formGestion.cumplimiento_retorno_doc" class="form-control">
                            <option value="SI">SI</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>

                    <div class="form-group mt-2 col-lg-4">
                        <label>Causa cumplimiento retorno</label>
                        <select v-model="formGestion.causa_retorno_doc" class="form-control">
                            <option value="NINGUNO">NINGUNO</option>
                            <option value="DEMORA POR ANW">DEMORA POR ANW</option>
                            <option value="DEMORA POR CASO FORTUITO">DEMORA POR CASO FORTUITO</option>
                            <option value="DEMORA POR CLIENTE DE DRAEGER">DEMORA POR CLIENTE DE DRAEGER</option>
                            <option value="DEMORA POR DRAEGER">DEMORA POR DRAEGER</option>
                        </select>
                    </div>
                </div>
            </div>

        </div>
        <div class="card bg-card mt-4">
            <div class="card-header">Selección de Vehículo</div>
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-lg-4">
                        <label class="required" for="vehiculo_selector">
                            Vehículo
                        </label>
                        <select v-model="formGestion.id_vehiculo" id="vehiculo_selector" @change="vehiculoSeleccionadoChange()" class="form-control font-small">
                            <option value="" disabled>Seleccione un vehículo</option>
                            <option v-for="veh in vehiculos" :key="veh.id_vehiculo" :value="veh.id_vehiculo">
                                {{ veh.nombre_vehiculo }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-lg-3">
                        <label>Chofer</label>
                        <input type="text" class="form-control" :value="vehiculoSeleccionado?.nombre_chofer || ''" readonly />
                    </div>
                    <div class="form-group col-lg-3">
                        <label>Auxiliar</label>
                        <input type="text" class="form-control" :value="vehiculoSeleccionado?.nombre_auxiliar || ''" readonly />
                    </div>
                    <div class="form-group col-lg-2">
                        <label>Placa</label>
                        <input type="text" class="form-control" :value="vehiculoSeleccionado?.placa_vehiculo || ''" readonly />
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="form-group mt-2 col-lg-12">
                <label>Observaciones</label>
                <textarea rows="10" v-model="formGestion.observaciones" class="form-control textarea-small"></textarea>
            </div>
        </div>


    </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
    name: 'ShippingANWPage',
    props: {
        envio: Object,
    },
    watch: {
        paquetes: {
            handler(newVal) {
                this.formGestion.cant_bultos = newVal.length
                this.formGestion.peso_volumen = newVal.reduce(
                    (total, p) => total + p.pesoVolumetrico,
                    0,
                )
                this.formGestion.peso_bruto = newVal.reduce((total, p) => total + p.peso, 0)
            },
            deep: true,
        },
    },

    data() {
        return {
            showdetalleUnidad: false,
            detalleUnidad: {},
            vehiculos:[],
            isLoading: true,
            tipoEnvio: this.$route.params.tipo_envio,
            modalDetalle: false,
            modalGestionANW: false,
            showModalArchivos: false,
            nombrePaquete: "",
            vehiculoSeleccionado:{},
            alto: "",
            ancho: "",
            largo: "",
            costoPorKg: "",
            pesoVolumetrico: "",
            pesoReal: "",
            costoPaquete: "",
            envioId: null,
            formDocumento: {
                guia_remitente: '',
                nro_pedido: '',
                orden_compra: '',
                numero_factura: '',
                guia_transportista: '',
                documentos_extras: ''
            },
            paquetes: [],
            estadosEnvio: [],
            causasConfomidad: [],
            causasEntregaCompleta: [],
            causasRetornoDocumentario: [
                { "id": 1, "nombre": "NINGUNO" },
                { "id": 2, "nombre": "DEMORA POR ANW" },
                { "id": 3, "nombre": "DEMORA POR CASO FORTUITO" },
                { "id": 4, "nombre": "DEMORA POR EL CLIENTE DE DRAEGER" }
            ]
            ,
            causasLlegadaDestino: [
                {
                    "id": 1,
                    "nombre": "NINGUNO"
                },
                {
                    "id": 2,
                    "nombre": "DEMORA POR CASO FORTUITO"
                },
                {
                    "id": 3,
                    "nombre": "DEMORA POR ANW"
                },
                {
                    "id": 4,
                    "nombre": "DEMORA POR CLIENTE DE DRAEGER"
                },
                {
                    "id": 5,
                    "nombre": "DEMORA POR DRAEGER"
                }
            ],
            codigosMetodoEnvio: [],
            solicitudesEnvio: [],
            formGestion: {},
            filtros: {
                tipo_paquete: "documentos",
                ruc: '',
                razon_social: '',
                cliente_final: '',
                pedido: '',
                guia: '',
                serie_guia: '',
                fecha_inicio: '',
                fecha_fin: '',
                id_modalidades_envio: '',
            },
            comentario: '',
            detalleEnvio: {},
            envios: [],
            empresas: [
                { id: 1, nombre: 'Empresa A' },
                { id: 2, nombre: 'Empresa B' },
            ],
            tipoUnidades: [
                { id: 3, tipo_unidad: 'Camión 10T' },
                { id: 4, tipo_unidad: 'Camión 20T' },
            ],
            archivos: [],
            nuevoArchivo: {
                tipo: '',
                archivo: null,
                nombre: '',
                comentario: '',
                url: null,
            },
            dragging: false,
        }
    },
    computed: {
        totalPaquetes() {
            return this.paquetes.length
        },
        totalPesoVolumetrico() {
            return this.paquetes.reduce((total, p) => total + p.pesoVolumetrico, 0)
        },
        totalPesoReal() {
            return this.paquetes.reduce((total, p) => total + p.peso, 0)
        },
        costoServicio() {
            return this.paquetes.reduce((total, p) => total + p.costo, 0);
        },
        costoVerificacion() {
            return this.costoServicio * 0.5;
        },
        costoTotal() {
            return Number((this.costoServicio + this.costoVerificacion).toFixed(2));
        }
    },
    mounted() {
        console.log("this.envio", this.envio)
        this.formGestion = this.envio
        console.log("this.formGestion", this.formGestion)
        this.getEstadosEnvio()
        this.getCausasConformidad()
        this.getCausasEntregaCompleta()
        this.getCodigoMetodoEnvio()
        this.getSolicitudesEnvio()
        this.getVehiculosInit();
      
    },
    methods: {
        async getVehiculosInit() {
            const response = await axios.get('/vehiculos-local-all')
            this.vehiculos = response.data;
            this.vehiculoSeleccionadoChange();
            console.log("vehiculos",this.vehiculos)
        },
         async getVehiculos() {
            const response = await axios.get('/vehiculos-local-all')
            this.vehiculos = response.data;
            console.log("vehiculos",this.vehiculos)
        },
         vehiculoSeleccionadoChange() {
            this.vehiculoSeleccionado= this.vehiculos.find(v => v.id_vehiculo === this.formGestion.id_vehiculo) || {};
            this.formGestion.personal_chofer = this.vehiculoSeleccionado.id_chofer ;
            console.log(" this.vehiculoSeleccionado", this.vehiculoSeleccionado)
        },
        async getCodigoMetodoEnvio() {
            try {
       
                const response = await axios.get('cod-metodo-envio')
                this.codigosMetodoEnvio = response.data
            } catch (error) {
                console.error('Error cargando códigos de método de envío:', error)
            }
        },
        async getSolicitudesEnvio() {
            try {
                const response = await axios.get('solicitudes-envio')
                this.solicitudesEnvio = response.data
            } catch (error) {
                console.error('Error cargando solicitudes de envío:', error)
            }
        },
        async getCausasConformidad() {
            try {
                const { data } = await axios.get('causas-incidencia')
                this.causasConfomidad = data
                this.isLoading = false;
            } catch (error) {
                console.error('Error al getCausasConformidad', error)
            }
        },
        async getCausasEntregaCompleta() {
            try {
                const { data } = await axios.get('causas-entrega-completa')
                this.causasEntregaCompleta = data
                this.isLoading = false;
            } catch (error) {
                console.error('Error al causasEntregaCompleta', error)
            }
        },
        agregarDocumento() {
            console.log("agregarDocumento")
            if (this.formDocumento.guia_transportista) {
                this.formGestion.detalles.push({ ...this.formDocumento });
                this.formDocumento = {
                    guia_remitente: '',
                    nro_pedido: '',
                    orden_compra: '',
                    numero_factura: '',
                    documentos_extras: ''
                };
            } else {
                alert('Debe ingresar al menos la guía de remisión');
            }
        },
        formatFecha(fecha) {
            if (!fecha) return ''
            const [year, month, day] = fecha.split('-')
            return new Date(year, month - 1, day).toLocaleDateString('es-PE', {
                dateStyle: 'short',
            })
        },

        abrirGestionarModal(item) {
            this.formGestion = item
            this.formGestion.lead_time_prometido_cargos = "4 HORAS"
            this.formGestion.lead_time_prometido_retorno = "5 DÍAS"
            this.modalGestionANW = true
            this.buscarPrecioConsolidado()
        },
        cerrarDetalle() {
            this.modalDetalle = false
        },
        obtenerNombreEmpresa(id) {
            return this.empresas.find((e) => e.id === id)?.nombre || 'No especificado'
        },
        obtenerTipoUnidad(id) {
            return (
                this.tipoUnidades.find((t) => t.id === id)?.tipo_unidad ||
                'No especificado'
            )
        },


        calcularCosto() {
            this.pesoVolumetrico = (this.alto * this.ancho * this.largo) / 5000
            let mayorPeso = Math.max(this.pesoReal, this.pesoVolumetrico)
            this.costoPaquete = parseFloat((mayorPeso * this.costoPorKg).toFixed(2))
        },

        agregarPaquete() {
            if (
                !this.nombrePaquete ||
                !this.alto ||
                !this.ancho ||
                !this.largo ||
                !this.pesoReal
            ) {
                alert('Completa todos los campos antes de agregar el paquete.')
                return
            }

            this.paquetes.push({
                nombre: this.nombrePaquete,
                alto: this.alto,
                ancho: this.ancho,
                largo: this.largo,
                peso: this.pesoReal,
                pesoVolumetrico: this.pesoVolumetrico,
                costo: this.costoPaquete,
            })

            // Limpiar los campos
            this.nombrePaquete = ''
            this.alto = ''
            this.ancho = ''
            this.largo = ''
            this.pesoReal = ''
            this.pesoVolumetrico = 0
            this.costoPaquete = 0
        },
        eliminarPaquete(index) {
            this.paquetes.splice(index, 1)
        },
        async getEstadosEnvio() {
            this.isLoading = true;
            const { data } = await axios.get('estados-envio')
            this.estadosEnvio = data
            this.isLoading = false;
        },
        async actualizarEnvio(accion) {
            try {
                await axios.get(`${accion}-envio/${this.detalleEnvio.id_envio}`)
                this.cerrarDetalle()
                this.buscarEnvios()
                Swal.fire({
                    icon: 'success',
                    title: 'Envío Actualizado',
                    text: 'Los datos se han actualizado correctamente.',
                })
            } catch (error) {
                console.error(`Error al ${accion} envío`, error)
            }
        },
        getBadgeClass(estado) {
            return (
                {
                    PENDIENTE: 'badge bg-warning',
                    ACEPTADO: 'badge bg-success',
                    RECHAZADO: 'badge bg-danger',
                }[estado] || 'badge bg-secondary'
            )
        },
        limpiarFiltros() {
            Object.keys(this.filtros).forEach(
                (key) =>
                    (this.filtros[key] = key === 'id_modalidades_envio' ? '3' : ''),
            )
            this.buscarEnvios()
        },
        submitDesdePadre() {
            return this.guardarGestion();
        },
        async guardarGestion() {
            console.log("formGestion", this.formGestion)
            try {
                await axios.post('gestion-anw-local', this.formGestion);
                Swal.fire({
                    icon: 'success',
                    title: 'Atención',
                    text: 'Los datos se actualizaron correctamente',
                })
            } catch (error) {
                console.error('Error al guardar los datos:', error);
            }
        },
    },
}
</script>

<style scoped>
.modal.fade.show {
    display: block;
}

.modal.show {
    background: rgba(0, 0, 0, 0.5);
}


.badge {
    font-size: 12px;
    padding: 3px 5px;
    border-radius: 5px;
}

.table-font-small {
    font-size: 0.75rem;
}

.table {
    table-layout: fixed;
    width: 100%;
}

.dropdown-menu {
    min-width: 180px;
}

.dropdown-item i {
    margin-right: 8px;
}

.custom-dropdown {
    position: absolute !important;
    /* Permite que se desplace sobre otras filas */
    z-index: 1050 !important;
    /* Asegura que esté sobre otros elementos */
    left: auto !important;
    /* Evita que se recorte en la tabla */
    right: 0 !important;
    /* Alinea correctamente */
}

.table-responsive {
    overflow: visible !important;
    /* Permite que el dropdown no se esconda */
}

.dropdown-menu.show {
    position: absolute !important;
    z-index: 1050 !important;
    will-change: transform;
}

.dropzone {
    border: 2px dashed #007bff;
    padding: 20px;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s;
}

.dropzone:hover,
.dropzone.drop-hover {
    background: rgba(0, 123, 255, 0.1);
}

.dropzone-content i {
    color: #007bff;
}

.dropzone-preview img {
    max-width: 100px;
    margin-top: 10px;
}

.swal2-container {
    z-index: 9999 !important;
}

.textarea-small {
    height: 100px;
}

.modal {
    z-index: 90;
}

#modalGestionANW label {
    font-size: 0.75rem;
}

.table> :not(caption)>*>* {
    padding: 0.325rem 0.85rem;
    background-color: var(--bs-table-bg);
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

/* Detalle */
</style>